module.exports = __webpack_public_path__ + "img/拳头.781907d6.gif";